// extracted by mini-css-extract-plugin
export var notificationHost = "_hj-0";